import { type IAdvancedRichText } from '../../../../../../inputs/rich-text-advanced/IAdvancedRichText.ts';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../../IWidgetType.ts';
import { type IInputWidget } from '../../IInputWidget.ts';
import { hasBlockLabelLayout } from '../label-layout/hasBlockLabelLayout.ts';
import { getWidgetProps } from '../util/getWidgetProps.ts';
import { hasWidgetHiddenLabel } from '../util/hasWidgetHiddenLabel.ts';

export interface ISelectWidgetWrapperProps
  extends IWidgetComponentProps<IInputWidget> {
  hidden?: boolean;
  formItemName?: string | string[];
  /** Se fornito, sovrascrive quella del widget */
  label?: IAdvancedRichText | undefined;
  /** Se fornito, sovrascrive quella del widget */
  helpText?: IAdvancedRichText | undefined;
}

/**
 * Componente per gestire in maniera centralizzata lo stile dei widget di tipo select (multi e single)
 */
export function SelectWidgetWrapper(props: ISelectWidgetWrapperProps) {
  const { children, label, helpText } = props;
  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      hidden={props.hidden}
      name={props.formItemName ?? options.name ?? 'string'}
      label={<RichTextAdvancedRender inline text={label ?? options.label} />}
      help={
        (helpText ?? options.helpText) ? (
          <RichTextAdvancedRender inline text={helpText ?? options.helpText} />
        ) : undefined
      }
      layout={{
        hideVisualLabel: options.hideLabel,
        removeLabelSpace: hasWidgetHiddenLabel(props.widget),
        labelLayoutBlock: hasBlockLabelLayout(props.widget),
      }}
      readonly={options.readonly}
      widget={props.widget}
    >
      {children}
    </ConfigFormItem>
  );
}
